import React from 'react';
import '../../styles/enterprise.css';

/**
 * Enterprise page header: large title + freshness line + right-aligned actions.
 *
 * <PageHeaderPro
 *   title="Transactions"
 *   eyebrow="Payouts"         // optional small label above the title
 *   subtitle="Manage…"        // optional sentence under the title
 *   mode="live"               // 'live' (green dot) | 'test' (amber dot)
 *   updatedText="Updated 2s ago"
 *   actions={<><button className="ent-btn ent-btn-secondary">Export</button>...</>}
 * />
 *
 * `eyebrow` and `subtitle` are additive — every existing caller omits them and
 * renders exactly as before.
 */
const PageHeaderPro = ({ title, eyebrow, subtitle, mode = 'live', updatedText, actions }) => {
  const isLive = mode === 'live';
  return (
    <div className="ent-page-head">
      <div>
        {eyebrow ? <span className="ent-page-head__eyebrow">{eyebrow}</span> : null}
        <h1 className="ent-page-head__title">{title}</h1>
        {subtitle ? <p className="ent-page-head__subtitle">{subtitle}</p> : null}
        <div className="ent-page-head__fresh">
          <span>
            <span className={`ent-dot ${isLive ? 'ent-dot--live' : 'ent-dot--test'}`} />
            {isLive ? 'Live mode' : 'Test mode'}
          </span>
          {updatedText ? (
            <>
              <span className="ent-page-head__sep">·</span>
              <span>{updatedText}</span>
            </>
          ) : null}
        </div>
      </div>
      {actions ? <div className="ent-page-head__actions">{actions}</div> : null}
    </div>
  );
};

export default PageHeaderPro;
